export const DATATEST = {
    root: "reusable__avatar-component",
};
